import { render, staticRenderFns } from "./ScheduleStatistics.vue?vue&type=template&id=2f700be9&scoped=true"
import script from "./ScheduleStatistics.vue?vue&type=script&lang=js"
export * from "./ScheduleStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f700be9",
  null
  
)

export default component.exports